import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Tabs } from 'ui/atoms'
import NewSwitch from 'ui/atoms/NewSwitch/NewSwitch'
import ModuleHeader from 'ui/components/ModuleHeader/ModuleHeader'
import styles from '../DayAheadTradingView.module.less'
import type { DayAheadTabDefinition } from '../DayAheadTradingView.types'
import { DayAheadDateSelector } from './DayAheadDateSelector'

export type PartitionSwitchOption = {
  key: string
  displayName: string
}

type DayAheadTradingHeaderProps = {
  tabs: DayAheadTabDefinition[]
  showTabs: boolean
  onTabChange: (tabId: string) => void
  canChangeTab?: (tabId: string) => boolean
  showPartitionSwitch: boolean
  partitionOptions: PartitionSwitchOption[]
  selectedPartitionKey: string
  onPartitionChange: (partitionKey: string) => void
}

export function DayAheadTradingHeader({
  tabs,
  showTabs,
  onTabChange,
  canChangeTab,
  showPartitionSwitch,
  partitionOptions,
  selectedPartitionKey,
  onPartitionChange,
}: DayAheadTradingHeaderProps): ReactNode {
  const { t } = useTranslation()

  return (
    <>
      <ModuleHeader
        infoHeader={
          <div className={styles.DayAheadTradingView_HeaderTitle}>
            <span>{t('Day Ahead Trading')}</span>
            {showPartitionSwitch && (
              <div className={styles.DayAheadTradingView_PartitionSwitch}>
                <NewSwitch
                  items={partitionOptions.map(({ key, displayName }) => ({ value: key, label: displayName }))}
                  value={selectedPartitionKey}
                  onClick={onPartitionChange}
                />
              </div>
            )}
            <DayAheadDateSelector />
          </div>
        }
        includePropertyFilter={false}
      />
      {showTabs && (
        <div className={styles.DayAheadTradingView_Tabs}>
          <Tabs
            items={tabs}
            onChange={(_, id) => {
              if (id) {
                onTabChange(id)
              }
            }}
            onBeforeChange={(_, id) => (id ? (canChangeTab?.(id) ?? true) : true)}
            innerLeftPadding
            marginBottom={false}
            uniqueStorageKey="DayAheadTradingTabs"
          />
        </div>
      )}
    </>
  )
}
